import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2602_7347)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_2602_7347)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M24 12.7209C24.0013 12.5332 23.9043 12.3586 23.7443 12.2604H23.7416L23.7315 12.2549L15.4152 7.33208C15.3793 7.30782 15.3421 7.28564 15.3036 7.26566C14.9825 7.1 14.6011 7.1 14.28 7.26566C14.2415 7.28565 14.2042 7.30782 14.1683 7.33208L5.85209 12.2549L5.84205 12.2604C5.58788 12.4185 5.50995 12.7527 5.66801 13.0069C5.71458 13.0818 5.77873 13.1441 5.85488 13.1886L14.1712 18.1114C14.2072 18.1355 14.2444 18.1576 14.2828 18.1778C14.6039 18.3435 14.9853 18.3435 15.3064 18.1778C15.3448 18.1576 15.382 18.1355 15.418 18.1114L23.7343 13.1886C23.9005 13.0918 24.0019 12.9132 24 12.7209Z",
					fill: "#0A2767"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.82157 9.43404H12.2791V14.4366H6.82157V9.43404ZM22.8837 4.34883V2.06046C22.8968 1.48831 22.4439 1.01371 21.8718 1H7.70958C7.13743 1.01371 6.68456 1.48831 6.69767 2.06046V4.34883L15.0698 6.58139L22.8837 4.34883Z",
					fill: "#0364B8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.69766 4.34885H12.279V9.3721H6.69766V4.34885Z",
					fill: "#0078D4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.8605 4.34885H12.2791V9.3721L17.8605 14.3953H22.8837V9.3721L17.8605 4.34885Z",
					fill: "#28A8EA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.2791 9.37207H17.8604V14.3953H12.2791V9.37207Z",
					fill: "#0078D4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.2791 14.3953H17.8604V19.4186H12.2791V14.3953Z",
					fill: "#0364B8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.82156 14.4366H12.279V18.9844H6.82156V14.4366Z",
					fill: "#14447D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.8604 14.3953H22.8837V19.4186H17.8604V14.3953Z",
					fill: "#0078D4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.7444 13.1579L23.7337 13.1635L15.4175 17.8407C15.3812 17.863 15.3444 17.8843 15.3058 17.9032C15.1646 17.9705 15.0112 18.0085 14.8549 18.0149L14.4005 17.7492C14.3622 17.7299 14.3249 17.7085 14.2889 17.685L5.86101 12.875H5.85711L5.58139 12.7209V22.1892C5.58569 22.8209 6.10112 23.3296 6.73283 23.3256H22.8664C22.8759 23.3256 22.8843 23.3211 22.8943 23.3211C23.0277 23.3126 23.1593 23.2851 23.285 23.2396C23.3393 23.2166 23.3918 23.1893 23.4418 23.1581C23.4792 23.1369 23.5434 23.0906 23.5434 23.0906C23.8293 22.879 23.9986 22.5449 24 22.1892V12.7209C23.9998 12.902 23.9021 13.069 23.7444 13.1579Z",
					fill: "url(#paint0_linear_2602_7347)"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M23.5535 12.6835V13.264L14.8577 19.2512L5.85488 12.8789C5.85488 12.8758 5.85238 12.8733 5.8493 12.8733L5.02325 12.3766V11.9579L5.36372 11.9524L6.08371 12.3654L6.10045 12.371L6.16184 12.41C6.16184 12.41 14.6232 17.2379 14.6456 17.2491L14.9693 17.4389C14.9972 17.4277 15.0251 17.4165 15.0586 17.4054C15.0753 17.3942 23.4586 12.6779 23.4586 12.6779L23.5535 12.6835Z",
					fill: "#0A2767"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.7443 13.1579L23.7337 13.1641L15.4175 17.8413C15.3812 17.8636 15.3443 17.8848 15.3058 17.9038C14.9829 18.0616 14.6052 18.0616 14.2822 17.9038C14.244 17.8848 14.2067 17.864 14.1706 17.8413L5.85432 13.1641L5.84428 13.1579C5.68372 13.0709 5.58305 12.9035 5.58139 12.7209V22.1892C5.58539 22.8208 6.10064 23.3296 6.73222 23.3256C6.73224 23.3256 6.73225 23.3256 6.73227 23.3256H22.8491C23.4807 23.3296 23.996 22.8208 24 22.1892C24 22.1892 24 22.1892 24 22.1892V12.7209C23.9998 12.902 23.9021 13.069 23.7443 13.1579Z",
					fill: "#1490DF"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M15.5386 17.7721L15.4141 17.8418C15.3781 17.8648 15.3408 17.8859 15.3025 17.9049C15.1654 17.9722 15.0163 18.0117 14.8638 18.021L18.0279 21.7628L23.5473 23.0928C23.6986 22.9786 23.8189 22.8283 23.8973 22.6558L15.5386 17.7721Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .05,
					d: "M16.1023 17.455L15.4141 17.8418C15.3781 17.8648 15.3408 17.8859 15.3025 17.9049C15.1654 17.9722 15.0163 18.0117 14.8638 18.021L16.3462 22.1082L23.549 23.0911C23.8328 22.8781 23.9998 22.544 24 22.1892V22.0669L16.1023 17.455Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.7479 23.3256H22.8474C23.0952 23.3268 23.3368 23.2486 23.5367 23.1023L14.4 17.7503C14.3616 17.731 14.3243 17.7096 14.2883 17.6861L5.86045 12.8761H5.85655L5.58139 12.7209V22.1568C5.58076 22.8017 6.10302 23.3249 6.7479 23.3256C6.74789 23.3256 6.74789 23.3256 6.7479 23.3256Z",
					fill: "#28A8EA"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M13.3953 6.48818V18.3933C13.3943 18.8107 13.1405 19.1859 12.7535 19.3421C12.6336 19.3937 12.5044 19.4203 12.3739 19.4203H5.58139V6.02325H6.69767V5.46512H12.374C12.9378 5.46725 13.3941 5.92432 13.3953 6.48818Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M12.8372 7.04631V18.9514C12.8386 19.0862 12.81 19.2197 12.7535 19.3421C12.5985 19.7242 12.2281 19.9748 11.8158 19.9767H5.58139V6.02324H11.8158C11.9778 6.02162 12.1374 6.06201 12.2791 6.14046C12.6212 6.31283 12.8371 6.6632 12.8372 7.04631Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M12.8372 7.04631V17.8351C12.8345 18.3987 12.3794 18.8556 11.8158 18.8604H5.58139V6.02324H11.8158C11.9778 6.02162 12.1374 6.06201 12.2791 6.14046C12.6212 6.31283 12.8371 6.6632 12.8372 7.04631Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M12.2791 7.04632V17.8351C12.2785 18.3996 11.8221 18.8577 11.2577 18.8604H5.58139V6.02325H11.2577C11.8221 6.02356 12.2794 6.48136 12.279 7.04577C12.2791 7.04595 12.2791 7.04614 12.2791 7.04632Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.02307 6.02325H11.256C11.821 6.02325 12.2791 6.4813 12.2791 7.04632V17.2792C12.2791 17.8443 11.821 18.3023 11.256 18.3023H1.02307C0.458037 18.3023 0 17.8443 0 17.2792V7.04632C0 6.4813 0.45805 6.02325 1.02307 6.02325Z",
					fill: "url(#paint1_linear_2602_7347)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M3.19758 10.3142C3.44973 9.777 3.85673 9.32742 4.36633 9.02326C4.93068 8.70016 5.57323 8.53909 6.22326 8.55776C6.82572 8.5447 7.4202 8.69742 7.94177 8.99925C8.43215 9.29169 8.82711 9.72018 9.0787 10.2327C9.35268 10.7975 9.48923 11.4191 9.47721 12.0467C9.49049 12.7026 9.35 13.3525 9.06698 13.9444C8.8094 14.4752 8.40192 14.919 7.89489 15.2208C7.35321 15.5319 6.73666 15.6886 6.11219 15.674C5.49686 15.6889 4.88927 15.5344 4.35573 15.2275C3.86109 14.9347 3.46119 14.5057 3.20373 13.9918C2.92811 13.4352 2.78994 12.8206 2.80075 12.1996C2.78927 11.5493 2.92493 10.9048 3.19758 10.3142ZM4.44335 13.3449C4.57778 13.6845 4.80577 13.9791 5.10083 14.1944C5.40137 14.4045 5.76125 14.5128 6.1278 14.5036C6.51817 14.5191 6.90295 14.407 7.22399 14.1844C7.51532 13.9697 7.73731 13.6744 7.8625 13.3349C8.00244 12.9557 8.0715 12.5541 8.06622 12.1499C8.07055 11.742 8.00563 11.3362 7.87422 10.9499C7.75815 10.6012 7.54332 10.2937 7.2558 10.0647C6.94281 9.83157 6.55906 9.7133 6.1691 9.72986C5.79461 9.72016 5.42667 9.82938 5.11813 10.0419C4.81807 10.2581 4.58577 10.5552 4.44837 10.8986C4.14356 11.6857 4.14198 12.5579 4.4439 13.346L4.44335 13.3449Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.8604 4.34885H22.8837V9.3721H17.8604V4.34885Z",
					fill: "#50D9FF"
				})
			]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_2602_7347",
			x1: 14.7907,
			y1: 12.7209,
			x2: 14.7907,
			y2: 23.3256,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#35B8F1" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#28A8EA"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_2602_7347",
			x1: 2.13312,
			y1: 5.22385,
			x2: 10.1459,
			y2: 19.1017,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#1784D9" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#107AD5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0A63C9"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2602_7347",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_2602_7347",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 22.3256,
				fill: "currentColor",
				transform: "translate(0 1)"
			})
		})
	] })]
});
export default SvgOutlook;
